import React, { useMemo } from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import styles from './score.module.scss';

const STATUSES = {
  DEFAULTED: 'DEF',
  RETIRED: 'RET',
  WALKOVER: 'WO',
  ABANDONED: 'ABD'
};

const ScoreCell = ({ data }: Partial<ICellRendererParams>) => {
  const statusesAbbreviated = useMemo(
    () => STATUSES[data.scores.status as keyof typeof STATUSES],
    [data.scores.status]
  );

  const statusesAbbreviatedTitle = useMemo(
    () =>
      Object.keys(STATUSES).find(
        key => STATUSES[key as keyof typeof STATUSES] === statusesAbbreviated
      ),
    [statusesAbbreviated]
  );

  let playerScore: string = '';
  let otherPlayerScore: string = '';
  let playerPointsScore: string = '';
  let otherPlayersPointsScore: string = '';

  /* The currently viewed player needs to always be on the left - so we need to know if they are the winner or the loser */
  if (data?.winningSide === null || data?.thisPlayerSide === data?.winningSide) {
    playerScore = 'winnerGamesWon';
    otherPlayerScore = 'loserGamesWon';
    playerPointsScore = 'winnerPointsWon';
    otherPlayersPointsScore = 'loserPointsWon';
  } else {
    playerScore = 'loserGamesWon';
    otherPlayerScore = 'winnerGamesWon';
    playerPointsScore = 'loserPointsWon';
    otherPlayersPointsScore = 'winnerPointsWon';
  }

  /* Loop through scores */
  if (data.scores && data.scores.sets) {
    let scores = data.scores.sets.map((setScore: any, ind: number) =>
      setScore[playerScore] === null &&
      setScore[otherPlayerScore] === null &&
      setScore.tiebreaker !== null ? (
        //Tiebreak set - no score, just a tiebreak.
        <span key={`${ind}-setScore`} className={styles.setScore}>
          [
          <span
            className={
              setScore.tiebreaker[playerPointsScore] > setScore.tiebreaker[otherPlayersPointsScore]
                ? styles.winner
                : ''
            }
          >
            {setScore.tiebreaker[playerPointsScore]}
          </span>
          <span className={styles.divider}>-</span>
          <span
            className={
              setScore.tiebreaker[playerPointsScore] < setScore.tiebreaker[otherPlayersPointsScore]
                ? styles.winner
                : ''
            }
          >
            {setScore.tiebreaker[otherPlayersPointsScore]}
          </span>
          ]
        </span>
      ) : (
        <span key={`${ind}-setScore`} className={styles.setScore}>
          <span
            className={
              data?.winningSide !== null && setScore[playerScore] > setScore[otherPlayerScore]
                ? styles.winner
                : ''
            }
          >
            {setScore[playerScore]}
            {setScore.tiebreaker !== null ? (
              <sup>{setScore.tiebreaker[playerPointsScore]}</sup>
            ) : null}
          </span>
          <span className={styles.divider}>-</span>
          <span className={setScore[playerScore] < setScore[otherPlayerScore] ? styles.winner : ''}>
            {setScore[otherPlayerScore]}
            {setScore.tiebreaker !== null ? (
              <sup>{setScore.tiebreaker[otherPlayersPointsScore]}</sup>
            ) : null}
          </span>
        </span>
      )
    );

    return (
      <span className={styles.scores}>
        {scores}
        <abbr className={styles.statusAbbreviated} title={statusesAbbreviatedTitle}>
          {statusesAbbreviated}
        </abbr>
      </span>
    );
  }

  return <></>;
};

export { ScoreCell };
